import React, { useState } from 'react';

import LogoAndBurgerMenu from './LogoAndBurgerMenu';
import MobileMenuItemsAndRewards from './MobileMenuItemsAndRewards';
import NavigationMenu from './NavigationMenu';
import { StyledContainer } from './styles';

const HeaderMobile = () => {
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <StyledContainer openMenu={openMenu}>
      <LogoAndBurgerMenu setOpenMenu={setOpenMenu} openMenu={openMenu} />
      {openMenu && <MobileMenuItemsAndRewards setOpenMenu={setOpenMenu} />}
      {openMenu && <NavigationMenu />}
    </StyledContainer>
  );
};

export default HeaderMobile;
